/**
 * Error tracking (P0-T15, SPEC-12 §6): Sentry in the client with
 * release = commit SHA. No-ops with a console warning when VITE_SENTRY_DSN is
 * not configured (P0 dev) — never silently pretending it is on (AGENTS.md §3
 * "no silent fallbacks").
 */
declare const __KN_APP_SHA__: string | undefined;

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const SHA = typeof __KN_APP_SHA__ !== 'undefined' ? __KN_APP_SHA__ : 'dev';

let enabled = false;

export async function initErrorTracking(): Promise<void> {
  if (!DSN) {
    console.warn(
      '[sentry] VITE_SENTRY_DSN not set — error tracking OFF (dev only; must be on for staging/production)',
    );
    return;
  }
  try {
    const Sentry = await import('@sentry/browser');
    Sentry.init({
      dsn: DSN,
      release: SHA,
      environment: import.meta.env.MODE,
      tracesSampleRate: 0.05,
      sampleRate: 1.0,
    });
    Sentry.setTag('app', 'client');
    enabled = true;
  } catch (e) {
    console.error('[sentry] init failed:', String((e as Error).message));
  }
}

/** test-error hook (P0-G10): callable from the console as __KN doesn't reach modules */
export function captureTestError(): string {
  const id = 'kn-client-test-' + Date.now().toString(36);
  if (enabled) {
    void import('@sentry/browser').then((Sentry) => {
      Sentry.captureException(new Error(id));
    });
  } else {
    console.warn(`[sentry] OFF — test error '${id}' logged locally only`);
  }
  return id;
}

if (typeof window !== 'undefined') {
  (window as unknown as { __knCaptureTestError: () => string }).__knCaptureTestError = captureTestError;
}
